import { CreateGatewayCustomer } from '../../purchases/dto/create-customer.dto'
import { CreateGatewayCard } from './create-customer-card.dto'

export class AssignNewCardDto {
    card: CreateGatewayCard = new CreateGatewayCard()
    customer: CreateGatewayCustomer = new CreateGatewayCustomer()
}
